import { Injectable } from '@angular/core';
// import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  async downloadPdf(html: HTMLElement, filename: string, suffix?: string): Promise<void> {
    const pdf = await this.convertToPDF(html);
    pdf.save(`${filename}${suffix ? '-' : ''}${suffix}.pdf`);
  }

  async getPdfOutput(html: HTMLElement, filename: string, suffix?: string): Promise<any> {
    const pdf = await this.convertToPDF(html);
    const formData = new FormData();
    formData.append('pdf', pdf.output('blob'), `${filename}${suffix ? '-' : ''}${suffix}`);
    return formData;
  }

  imageToFormData(image: any) {
    const base64ImageContent = image.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
    const blob = this.base64ToBlob(base64ImageContent, 'image/jpeg');
    const formData = new FormData();
    formData.append('image', blob);
    return formData;
  }

  fileToFormData(file: any) {
    const base64Content = file.replace(/^data:application\/.*;base64,/, '');
    const blob = this.base64ToBlob(base64Content, 'application/octet-stream');
    const formData = new FormData();
    formData.append('file', blob);
    return formData;
  }

  private async convertToPDF(html: HTMLElement): Promise<any> {
    const pdf = new jsPDF('p', 'mm', 'a4', true);
    await pdf.html(html, {
      margin: 10,
      html2canvas: {
        scale: 187 / html.clientWidth,
      },
      autoPaging: 'text',
    });
    const pageCount = pdf.internal.pages.length;
    pdf.deletePage(pageCount);
    if (pageCount > 2) {
      pdf.deletePage(pageCount - 1);
      pdf.deletePage(pageCount - 2);
      pdf.deletePage(pageCount - 3);
      pdf.deletePage(pageCount - 4);
      pdf.deletePage(pageCount - 5);
    }

    return pdf;
  }

  private base64ToBlob(base64, mime) {
    mime = mime || '';
    const sliceSize = 1024;
    const byteChars = window.atob(base64);
    const byteArrays = [];

    for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
      const slice = byteChars.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mime });
  }
}
